"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        var _vm$selectedLot$roots, _vm$selectedLot$scion, _vm$selectedLot$cutti;
        return [_c("section", {
          staticClass: "move-lot-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Mover Lotes\n        ")]), _vm._v(" "), _vm.selectedLot ? _c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: _vm.clearSelection
          }
        }, [_c("span", {
          staticClass: "icon"
        }, [_c("i", {
          staticClass: "icon-ic_voltar"
        })]), _vm._v(" "), _c("span", [_vm._v("Voltar para seleção")])]) : _vm._e()], 1), _vm._v(" "), !_vm.selectedLot ? _c("div", {
          staticClass: "page-content"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n          Selecione um lote para mover os locais\n        ")]), _vm._v(" "), _c("LotsList", {
          attrs: {
            lots: _vm.lots,
            "is-loading": _vm.isLoadingLots
          },
          on: {
            onSearchChange: _vm.handleLotsSearch
          },
          model: {
            value: _vm.selectedLot,
            callback: function callback($$v) {
              _vm.selectedLot = $$v;
            },
            expression: "selectedLot"
          }
        })], 1) : _c("div", {
          staticClass: "page-content"
        }, [_c("div", {
          staticClass: "selected-lot-info"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Lote selecionado: " + _vm._s(_vm.selectedLot.code) + "\n          ")]), _vm._v(" "), _c("p", {
          staticClass: "lot-details"
        }, [_vm.selectedLot.type === "graft" ? [_c("strong", [_vm._v("Cavalo:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$roots = _vm.selectedLot.rootstock) === null || _vm$selectedLot$roots === void 0 ? void 0 : _vm$selectedLot$roots.name) || "--") + " |\n              "), _c("strong", [_vm._v("Copa:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$scion = _vm.selectedLot.scion) === null || _vm$selectedLot$scion === void 0 ? void 0 : _vm$selectedLot$scion.name) || "--") + "\n            ")] : _vm.selectedLot.type === "cut" ? [_c("strong", [_vm._v("Estaquia:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$cutti = _vm.selectedLot.cutting) === null || _vm$selectedLot$cutti === void 0 ? void 0 : _vm$selectedLot$cutti.name) || "--") + "\n            ")] : _vm._e()], 2)]), _vm._v(" "), _c("form", {
          on: {
            submit: function submit($event) {
              $event.preventDefault();
              return _vm.submitForm.apply(null, arguments);
            }
          }
        }, [_c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Informações da movimentação\n            ")]), _vm._v(" "), _c("div", {
          staticClass: "form-row"
        }, [_c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Descrição (opcional)"
          }
        }, [_c("b-input", {
          attrs: {
            placeholder: "Descreva o motivo da movimentação...",
            type: "textarea",
            rows: "2"
          },
          model: {
            value: _vm.form.description,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "description", $$v);
            },
            expression: "form.description"
          }
        })], 1), _vm._v(" "), _c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Data da movimentação"
          }
        }, [_c("b-datepicker", {
          attrs: {
            placeholder: "Selecione a data",
            icon: "calendar-today",
            required: ""
          },
          model: {
            value: _vm.form.transferAt,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "transferAt", $$v);
            },
            expression: "form.transferAt"
          }
        })], 1)], 1)]), _vm._v(" "), _c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Locais de origem\n            ")]), _vm._v(" "), _c("p", {
          staticClass: "section-description"
        }, [_vm._v("\n              Selecione os locais que serão reorganizados neste lote.\n            ")]), _vm._v(" "), _c("LotInventorySelector", {
          attrs: {
            inventories: _vm.selectedLot.inventories || [],
            label: "Selecione os locais para mover",
            "quantity-label": "Quantidade a mover",
            "quantity-placeholder": "Qtd.",
            "empty-message": "Este lote não possui locais disponíveis.",
            "hide-quantity-field": ""
          },
          model: {
            value: _vm.form.senderInventories,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "senderInventories", $$v);
            },
            expression: "form.senderInventories"
          }
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Novos locais de destino\n            ")]), _vm._v(" "), _c("p", {
          staticClass: "section-description"
        }, [_vm._v("\n              Defina os novos locais onde os locais serão realocados dentro do mesmo lote.\n            ")]), _vm._v(" "), _c("SectionRowInventories", {
          attrs: {
            "show-quantity": true,
            "min-items": 1,
            "max-items": 10
          },
          model: {
            value: _vm.form.destinationInventories,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "destinationInventories", $$v);
            },
            expression: "form.destinationInventories"
          }
        }), _vm._v(" "), _vm.destinationRowMissing ? _c("div", {
          staticClass: "quantity-alert"
        }, [_c("b-message", {
          attrs: {
            type: "is-warning",
            "has-icon": ""
          }
        }, [_c("strong", [_vm._v("Atenção:")]), _vm._v(" Selecione as ruas antes de confirmar.\n              ")])], 1) : _vm._e(), _vm._v(" "), _vm.quantityMismatch ? _c("div", {
          staticClass: "quantity-alert"
        }, [_c("b-message", {
          attrs: {
            type: "is-warning",
            "has-icon": ""
          }
        }, [_c("strong", [_vm._v("Atenção:")]), _vm._v(" Quantidade de origem (" + _vm._s(_vm.senderTotal) + ") diferente da\n                quantidade de destino (" + _vm._s(_vm.receiverTotal) + "). As quantidades devem ser iguais.\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), _c("div", {
          staticClass: "form-actions"
        }, [_c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            "native-type": "submit",
            type: "is-primary",
            loading: _vm.isSubmitting,
            disabled: _vm.isSubmitting || _vm.quantityMismatch
          }
        }, [_vm._v("\n              Confirmar movimentação\n            ")]), _vm._v(" "), _c("b-button", {
          attrs: {
            type: "is-text",
            disabled: _vm.isSubmitting
          },
          on: {
            click: _vm.handleCancel
          }
        }, [_vm._v("\n              Cancelar\n            ")])], 1)])])])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;